import React from "react";
import TextInput from "../../../../components/Input/TextInput";
import { Group } from "@mantine/core";

const VehiclePriceDropdown = ({ form }) => {
  return (
    <Group>
      <TextInput label={"Vehicle Price"} placeholder="Vehicle Price" form={form} validateName="vehicleRetailPrice" size="xs" />
      <TextInput
        label={"Total Cost"}
        placeholder="Total Cost"
        form={form}
        validateName="vehicleCostPrice"
        size="xs"
        disabled={form.values.vehicle != null}
      />
    </Group>
  );
};

export default VehiclePriceDropdown;
